// extracted by css-extract-rspack-plugin
export default {"whiteButton":"whiteButton-avvF9u","sourceWhaleIcon":"sourceWhaleIcon-ir0DFz"};